<template>
    <div class="product-wrapper-grid" :class="listViewEnable ? 'list-view' : ''">
        <div class="row">
            <div :class="[name ? 'col-md-6' : col3 ? 'col-lg-4 col-md-6' : col4 ? 'col-xl-3 col-md-6' : col6 ? 'col-xl-2 col-lg-4 col-md-6' : list ? 'col-xl-12' : 'col-xl-3 col-md-6',]"
                v-for="(product, index) in filterPage" :key="index">
                <div class="card">
                    <div class="product-box">
                        <div class="product-img">
                            <div class="ribbon ribbon-danger" v-if="product.sale">Sale</div>
                            <img class="img-fluid" :src="getImgUrl(product.img[0])" alt />
                            <div class="product-hover">
                                <ul>
                                    <router-link :to="'/ecommerce/cart'">
                                        <li @click="addToCart(product)"> <i class="icon-shopping-cart"> </i></li>
                                    </router-link>
                                    <li @click="quickView(product)" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                        <i class="icon-eye"> </i>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="product-details">
                            <router-link :to="'/ecommerce/product/page/' + product.id">
                                <h4>{{ product.name }}</h4>
                            </router-link>
                            <p>{{ product.note }}</p>
                            <div class="product-price">
                                ${{ product.price }}<del>${{ product.discountPrice }}</del>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="exampleModal" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="product-box row">
                        <div class="product-img col-lg-6">
                            <img class="img-fluid" :src="getImgUrl(quickViewProduct.imge || 'ecommerce/01.jpg')" alt="" />
                        </div>
                        <div class="product-details col-lg-6 text-start">
                            <router-link :to="'/ecommerce/product/page/' + quickViewProduct.id">
                                <h4>{{ quickViewProduct.name }}</h4>
                            </router-link>
                            <div class="product-price">
                                ${{ quickViewProduct.price }}<del>${{ quickViewProduct.discountPrice }} </del>
                            </div>
                            <div class="product-view">
                                <h6 class="f-w-600">Product Details</h6>
                                <p class="mb-0"> Sed ut perspiciatis, unde omnis iste natus error sit voluptatem
                                    accusantium doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo. </p>
                            </div>
                            <div class="product-size">
                                <ul class="d-flex align-items-center gap-2 mb-2">
                                    <li> <button class="btn btn-outline-light" type="button" data-bs-original-title=""
                                            title="">M</button></li>
                                    <li> <button class="btn btn-outline-light" type="button" data-bs-original-title=""
                                            title="">L</button></li>
                                    <li> <button class="btn btn-outline-light" type="button" data-bs-original-title=""
                                            title="">Xl</button> </li>
                                </ul>
                            </div>
                            <div class="product-qnty">
                                <h6 class="f-w-600">Quantity</h6>
                                <fieldset>
                                    <div class="input-group bootstrap-touchspin">
                                        <button class=" btn btn-primary btn-square bootstrap-touchspin-down " type="button"
                                            data-bs-original-title="" title="" @click="decrement()">
                                            <i class="fa fa-minus"></i></button>
                                        <input class="touchspin1 text-center" v-model="counter" name="quantity"
                                            type="text" />
                                        <button class="btn btn-primary btn-square bootstrap-touchspin-up" type="button"
                                            data-bs-original-title="" title="" @click="increment()">
                                            <i class="fa fa-plus"></i></button>
                                    </div>
                                </fieldset>
                                <div class="addcart-btn mt-3">
                                    <router-link to="/ecommerce/cart">
                                        <button class="btn btn-primary m-r-10" type="button" data-bs-dismiss="modal"
                                            data-original-title="btn btn-info-gradien" title
                                            @click="addToCart(quickViewProduct, counter)">Add To Cart</button>
                                    </router-link>
                                    <router-link :to="'/ecommerce/checkout'" class="btn btn-primary cart-btn-transform">
                                        <div data-bs-dismiss="modal">Buy Now</div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="btn-close" type="button" data-bs-dismiss="modal"></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import productMixin from "@/mixins/productMixin"
export default {
    mixins: [productMixin],
}
</script>